// extracted by mini-css-extract-plugin
export default {"sponsoredBanner":"oX-z","sponsoredTooltipWrapper":"pX-z","sponsoredTooltip":"qX-z","newCard":"rX-z"};